import * as React from "react";
import MxMenu from "@rf-l1/MxMenu";
import MxIcons from "@rf-l1/MxIcons";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import useUserHasPermission from "@/shared/hooks/use-useris.hook";
import { useLoggedUser } from "@/shared/store/auth";
import { ERolesCode } from "@/shared/models/enums/roles/roles-code.enum";
import { C_PROPERTIES_STATUS } from "@/src-refactor/modules/shared/model/const/property/real-estate-status";
import { Unit } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import { usePropertyDetailPage } from "../../../context/PropertyDetailPageContext";
import useReadOnlyModeGuard from "@rf-hooks/useReadOnlyModeGuard";

interface I_MenuOptionTableDetail {
  unit: Unit;
}
function MenuOptionTableDetail(props: I_MenuOptionTableDetail) {
  const { guardReadOnlyAction } = useReadOnlyModeGuard();
  const propertyData = usePropertyDetailPage();
  const { userIs } = useUserHasPermission();
  const {
    userLogged: { userData }
  } = useLoggedUser();

  const drop = () => {
    guardReadOnlyAction("dar de baja unidad", "property-unit-actions");
  };

  const userLoggedIsCreator = React.useMemo(
    () => propertyData.agents.some(item => item.id === userData?.people_id),
    [propertyData.agents, userData?.people_id]
  );
  const isSuperAdmin = userIs(ERolesCode.SUPER_ADMIN);

  const propertyIsDrop = props.unit.status_id === C_PROPERTIES_STATUS.DROPPED.id;

  const ActionMenu = {
    canDrop: (userLoggedIsCreator || isSuperAdmin) && !propertyIsDrop
  };

  const menuItems = [
    {
      label: "Dar de baja",
      onClick: drop,
      show: ActionMenu.canDrop
    }
  ].filter(item => item.show);

  return (
    <div>
      <MxMenu items={menuItems} width={200}>
        <MxIcons
          size={16}
          color="primary"
          sx={{ cursor: "pointer", padding: "10px" }}
        >
          <MoreVertIcon />
        </MxIcons>
      </MxMenu>
    </div>
  );
}

export default MenuOptionTableDetail;
